"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var EmailExclusivesProductCards_1 = require("../ShopAll/EmailExclusivesProductCards");
var EmailExclusivesSection = function (_a) {
    var products = _a.products, subCollection = _a.subCollection, sectionSubHeader = _a.sectionSubHeader, isBundle = _a.isBundle, bundleDiscount = _a.bundleDiscount;
    var isDesktop = window.innerWidth >= 1025;
    var filtered = products.filter(function (val) {
        return val.metafields.sub_collection == subCollection;
    });
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { class: "anchor", id: "anchor--".concat(subCollection) }),
        (0, preact_1.h)("div", { class: "shop-all-container email-exclusives-section" },
            (0, preact_1.h)("div", { class: "sales-section__header-container" },
                (0, preact_1.h)("p", { class: "sales-section__header" },
                    "Shop\u00A0",
                    (0, preact_1.h)("span", null, subCollection))),
            (0, preact_1.h)("p", { class: "sales-section__subheader" },
                (0, preact_1.h)("div", { dangerouslySetInnerHTML: { __html: sectionSubHeader } })),
            (0, preact_1.h)(EmailExclusivesProductCards_1.default, { isDesktop: isDesktop, products: filtered, isBundle: isBundle, bundleDiscount: bundleDiscount }),
            subCollection == 'bundles' && ((0, preact_1.h)("a", { class: "sales-section__link", href: "/collections/shop-bundles" }, "Discover More Bundles")))));
};
exports.default = EmailExclusivesSection;
